<template>
	<div>
        <el-table
            :data="tableData"
            border
            v-loading="listLoading"
            highlight-current-row
		>
			<el-table-column prop="Id" label="ID" align="center" width="60"></el-table-column>
			<el-table-column prop="IndString1" label="模式类型" align="center" min-width="120"></el-table-column>
			<el-table-column prop="IndInt2" label="范围" align="center" width="">
                <template scope="scope">
                    <el-input v-model="scope.row.IndInt2" placeholder="请输入范围" clearable size="small"></el-input>
                </template>
            </el-table-column>
			<el-table-column prop="IndInt3" label="可延长范围" align="center" width="">
                <template scope="scope">
                    <el-input v-model="scope.row.IndInt3" placeholder="请输入可延长范围" clearable size="small"></el-input>
                </template>
            </el-table-column>
			<el-table-column prop="IndString3" label="单位" align="center" width=""></el-table-column>
			<el-table-column prop="IndString2" label="应用端" align="center" width=""></el-table-column>
			<el-table-column prop="CreateUsername" label="最后修改人" align="center" width=""></el-table-column>
			<el-table-column prop="UpdateTime" label="更新时间" align="center" min-width="130"></el-table-column>
			<el-table-column prop="" label="操作" align="center" width="120">
                <template scope="scope">
                    <el-button @click="updateRow(scope.row)" type="text">更新</el-button>
                </template>
            </el-table-column>
		</el-table>
	</div>
</template>
<script>
import { getPublicDictionaryList,updateFzscDataById } from '../../api/api'
import util from "../../../util/date";
export default {
	data() {
		return {
            listLoading: false,
            tableData: [],
		}
	},
	methods: {
		getTableData() {
            var params = {}
            this.listLoading = true
            getPublicDictionaryList(params).then(res => {
                var result = res.data
                if(result.Success) {
                    this.tableData = result.Response
                }
                this.listLoading = false
            })
        },
        // 更新
        updateRow(row) {
            var params = {
                dataId: row.Id,
                dataValue: row.IndInt2,
                extend: row.IndInt3,
            }
            updateFzscDataById(params).then(res => {
                var result = res.data
                if(result.Success) {
                    this.$message.success(result.Message)
                } else {
                    this.$message.error(result.Message)
                }
            })
        },
		//时间格式化
		formatCreateTime: function(row, column) {
			return !row.CreateTime || row.CreateTime == ""
            ? ""
            : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
		},
	},
	mounted() {
		this.getTableData()
	},
}
</script>

<style lang="stylus" scoped>

</style>